module.exports = __webpack_public_path__ + "static/media/instagram-link.1ea948c3.svg";